import avatar5 from "../../assets/images/avatar-5.png";
import avatar6 from "../../assets/images/avatar-6.png";
import avatar7 from "../../assets/images/avatar-7.png";
import avatar10 from "../../assets/images/avatar-10.png";
import avatar11 from "../../assets/images/avatar-11.png";
import avatar13 from "../../assets/images/avatar-13.png";
import avatar14 from "../../assets/images/avatar-14.png";
import avatar16 from "../../assets/images/avatar-16.png";
import avatar17 from "../../assets/images/avatar-17.png";
import avatar24 from "../../assets/images/avatar-24.png";
import avatar26 from "../../assets/images/avatar-26.png";

const sidechatdata = [
  {
    name: "Natali Craig",
    message: "Are you free tonight?",
    timestamp: "19:28",
    unreadCount: 12,
    avatar: avatar6,
    multipleavatar: false,
    selectedchat: true
  },
  {
    name: "Sarah Jackson, Michael Brown, Christopher Lee",
    message: "Yes, I think it's a great idea",
    timestamp: "Mar 12",
    avatar1: avatar16,
    avatar2: avatar14,
    avatar3: avatar7,
    multipleavatar: true,
    selectedchat: false
  },
  {
    name: "Group",
    message: "I'll go with him",
    timestamp: "Mar 12",
    unreadCount: 12,
    avatar1: avatar17,
    avatar2: avatar5,
    avatar4: avatar26,
    multipleavatar: true,
    numavatar: 3,
    selectedchat: false
  },
  {
    name: "William Johnson",
    message: "What about the second plan",
    timestamp: "Mar 11",
    avatar: avatar5,
    multipleavatar: false,
    selectedchat: false
  },
  {
    name: "John Smith",
    message: "There's a bug you need to deal with.",
    timestamp: "Mar 10",
    avatar: avatar11,
    multipleavatar: false,
    selectedchat: false
  },
  {
    name: "Michael Brown",
    message: "Let's play a game",
    timestamp: "Mar 9",
    unreadCount: 12,
    avatar: avatar13,
    multipleavatar: false,
    selectedchat: false
  },
  {
    name: "Kate Morrison",
    message: "I think we should use the first version.",
    timestamp: "Mar 9",
    avatar: avatar10,
    multipleavatar: false,
    selectedchat: false
  },
  {
    name: "Catherine",
    message: "Let's talk about the search box interaction again",
    timestamp: "Mar 8",
    avatar: avatar24,
    multipleavatar: false,
    selectedchat: false
  },
];

export { sidechatdata };
